import * as management from './accessoriesRequests';

const reducers = {
  ...management,
};

export default reducers;
